import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {MessageContact} from "../../model/MessageContact";
import {ChatMessageService} from "../../message.service";
import {MessageChatComponent} from '../message-chat/message-chat.component';
declare let iNet: any;

@Component({
  selector: 'message-panel',
  templateUrl: './message-panel.component.html',
  styleUrls: ['./message-panel.component.scss']
})
export class MessagePanelComponent implements OnInit, AfterViewInit,  OnDestroy {
  @Input() audioCall: boolean = true;
  @Input() videoCall: boolean = true;
  @Input() closable: boolean = false; // Support close button on small screen
  @Output() unreadMessageChange = new EventEmitter<number>();
  @ViewChild(MessageChatComponent) messageChatComponent!: MessageChatComponent;

  contact?: MessageContact | null;
  chatOpen: boolean = false;
  readyToChat: boolean = false;
  stateMessage?: string;
  roomName?: string | null;
  private readonly _socketSub: any;
  private readonly _messageSub: any;

  constructor(private messageService: ChatMessageService) {
    this._socketSub = this.messageService.socketService.onStateChange.subscribe(() => this._stateChange());
    this._messageSub = this.messageService.unreadMessageChange.subscribe((count) => this.unreadMessageChange.emit(count));
    this._stateChange();
  }

  private _stateChange() {
    this.readyToChat = this.messageService.socketService.connected;
    if (this.messageService.socketService.connected) {
      this.stateMessage = '';
    } else if (this.messageService.socketService.closed) {
      this.stateMessage = 'Kết nối không thành công';
    } else {
      this.stateMessage = 'Đang kết nối...';
    }
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    this._socketSub.unsubscribe();
    this._messageSub.unsubscribe();
  }

  openVideoCall(contact: MessageContact) {

  }

  openAudioCall(contact: MessageContact) {

  }

  openChatWith(contact: MessageContact, call?: boolean) {
    this.roomName = null;
    if(!contact) {
      return;
    }
    if (this.contact !== contact) {
      this.contact = contact;
      contact.unread = 0; // mark read
    }
    // Delay for chat
    setTimeout(() => {
      this.chatOpen = true;
      if (call) {
        this.messageChatComponent.messageJoinCall['joined'] = false;
        this.messageChatComponent.joinRoom(true, contact.usercode);
      }
    }, 100);
  }

  closeChat() {
    this.chatOpen = false;
  }

  openRoom(roomName: any) {
    this.contact = null;
    this.roomName = roomName;
  }

  callToContactSelected(contact: any) {
    this.openChatWith(contact, true);
  }
}
